﻿module Sm.UI.Components.Control

open System
open Fable.DateFunctions

open Browser.Types
open Fable.React
open Fable.React.Props
open MobF.React

open Sm.Core.Date

open Sm.UI.Form.Control
open Sm.UI.Form.DateInput

let dataAttributes map =
    ([], map) ||> Map.fold (fun attr key value ->
        Data (key, value) :> IHTMLProp :: attr
    )

let renderButton (b: Button<_>) (handler: _ -> unit) =
    let classList = renderClassList [
        Toggle ("is-subtle", b.State.Subtle)
        Toggle ("is-down", b.State.Down)
        Toggle ("is-disabled", b.State.Disabled)
        yield! b.State.Classes |> List.map Append
    ]

    let onClick (e: MouseEvent) =
        e.stopPropagation()

        if b.State.Subtle then
            e.preventDefault ()

        if not b.State.Disabled then
            handler b.Command

    let element =
        let attrs: IHTMLProp list = [
            Class classList
            Disabled b.State.Disabled
            OnClick onClick
            yield! dataAttributes b.State.Attributes
        ]
        if b.State.Subtle then a (Href "" :: attrs)
        else button attrs

    let labelElement =
        if b.State.Subtle then span else label

    element [
        match b.Content with
        | Empty -> nothing
        | Label s -> labelElement [] [str s]
        | Icon name -> iconFor name []
        | IconAndLabel (icn, lbl) -> 
            iconFor icn []
            labelElement [] [str lbl]
    ]

[<ObserverComponent>]
let DayView (props: {| Day: Day<_>; OnSelect: DateOnly -> unit; ShowMarks: bool |}) =
    let day = props.Day

    let dt = day.Date.DateTime
    let dayOfMonth = dt.GetDayOfMonth()
    let dayName = dt.Format("EEEEEE")

    let style =
        if dayOfMonth = 1 then
            let dayOfWeek =
                dt
                |> Weekday.fromDate
                |> Weekday.toOrdinal
            Style [GridColumn dayOfWeek]
        else Style []

    let classList = renderClassList [
        Append "day"
        Append (sprintf "is-%s" <| dayName.ToLowerInvariant())
        Toggle ("is-weekend", match day.Date.DayOfWeek with DayOfWeek.Saturday | DayOfWeek.Sunday -> true | _ -> false)
        Toggle ("is-first-day-of-month", dayOfMonth = 1)
        Toggle ("is-first-week-of-month", dayOfMonth <= 7)

        match day.Availability with
        | Unavailable -> Append "is-unavailable"
        | Busy -> Append "is-busy"
        | Available -> Append "is-available"

        Toggle ("is-today", day.IsToday)
        Toggle ("is-current-month", day.IsCurrentMonth)
        Toggle ("is-selected", day.IsSelected)
        Toggle ("is-showing-marks", props.ShowMarks)
        Toggle ("is-marked", props.ShowMarks && day.IsMarked)
    ]

    let onClick _ =
        match day.Availability with
        | Available -> props.OnSelect day.Date
        | _ -> ()

    div [Class classList; style; OnClick onClick] [
        if dayOfMonth = 1 then
            span [Class "month-name"] [str (dt.Format("MMM"))]

        span [Class "date"] [strf "%i" dayOfMonth]

        if day.IsToday then
            em [Class "corner"] []
    ]

[<ObserverComponent>]
let DayNames () =
    div [Class "day-names"] [
        for x in 1 .. 7 do
            span [] [
                Weekday.fromOrdinal x
                |> Option.defaultValue Monday
                |> Weekday.shortName
                |> str
            ]
    ]
